import { productSans } from '@/constants/fonts';

export default function Footer() {
  return (
    <div className={`w-screen ${productSans.className}`}>
      <div className="mx-auto flex max-w-[1440px] items-center justify-between p-4 max-md:flex-col max-md:items-start max-md:gap-6">
        <div className="flex flex-wrap items-center gap-1 font-sans text-sm font-light text-white/80">
          <span className="text-base">©</span> <span>2025 Umay Labs LLP</span>
          <hr className="mx-1 h-3 w-[1px] bg-white/80" />
          <span> BIN: 210840005337</span>
          <hr className="mx-1 h-3 w-[1px] bg-white/80" /> <span>Almaty, Kazakhstan</span>
        </div>

        <div className="text-base text-white max-lg:text-[18px]">All rights reserved.</div>
      </div>
    </div>
  );
}
